module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid18_800x499.6172f4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid18_800x499.jpg
// module id = Vwoe
// module chunks = 0